import { useRouter } from 'next/router';
import { heroValuePartner } from '../../../constants/partnerPageConst';
import {
  excludedRegexList,
  getCategoryName,
  includedRegexList,
} from '../../../utils/getCategory';
import { handleTrack } from '../../../utils/tracker';
import { Button } from '../../Atoms/Button';
import { setQueryParamToLink } from '../../Header/utils';
import { HEADER_LABELS } from './DataConstants';

export const RadCTA: React.FC = (): JSX.Element => {
  const router = useRouter();
  const pathName = router.asPath;

  const pageName = getCategoryName({
    regexList: [...includedRegexList, ...excludedRegexList],
    url: pathName,
    parent: true,
  });
  const refValue = `${pageName}_pages_navbar`;

  return (
    <div className="sm:px-0 sm:py-2 whitespace-nowrap cursor-pointer border border-blue-350 rounded-3xl hover:bg-blue-350 ">
      <a
        href={`https://www.cleartax.in/s/contact-sales?utm_ref=${refValue}&ref=${pathName}`}
        target="_blank"
        rel="noreferrer"
        className="button inline-flex items-center py-2 font-semibold lg:w-auto rounded-lg text-s-14 w-full whitespace-nowrap text-blue-350 hover:text-white"
        data-label="clear-in-rad"
        onClick={(e) => handleTrack({ label: 'navbar-button', obj: e.target })}
      >
        {HEADER_LABELS.demo}
      </a>
    </div>
  );
};

interface IStartFilingCTA {
  href?: string;
  btnText?: string;
}

export const RequestDemoDrawerForm = ({
  btnText,
  cbFn,
}: {
  btnText: string;
  cbFn: () => void;
}) => {
  return (
    <Button
      rounded="sm"
      className="px-5 py-2.5 bg-blue-350 focus:outline-none sm:ml-0 sm:my-2"
      id="menu-button"
      onClick={cbFn}
    >
      {btnText}
    </Button>
  );
};

export const StartFilingCTA: React.FC<IStartFilingCTA> = ({
  href = heroValuePartner.btnLink,
  btnText = 'Get Started',
}) => {
  const router = useRouter();
  const pageName = getCategoryName({
    regexList: [...includedRegexList, ...excludedRegexList],
    url: router.asPath,
    parent: true,
  });
  const refValue = `${pageName}_pages_navbar`;
  const link = setQueryParamToLink(href, 'utm_ref', refValue);

  return (
    <a
      href={link}
      rel="noreferrer"
      className="text-white"
      onClick={(e) => handleTrack({ label: 'navbar-button', obj: e.target })}
    >
      <Button
        rounded="sm"
        className="px-5 py-2.5 bg-blue-350 focus:outline-none sm:ml-0 sm:my-2"
        id="menu-button"
      >
        {btnText}
      </Button>
    </a>
  );
};
